export const pt = {
  "REQUIRED_ACTION_KeepCapturing": "Continue capturando.",
  "REQUIRED_ACTION_PauseCapturing": "Pausar Captura",
  "REQUIRED_ACTION_Close": "Fechar",
  "REQUIRED_ACTION_Error": "Erro",
  "REQUIRED_ACTION_AGREE": "Concordo",
  "REQUIRED_ACTION_DISAGREE": "Não concordo",
  "LIVENESS_ACTION_Smile": "Sorriso",
  "LIVENESS_ACTION_Frown": "franzir a testa",
  "LIVENESS_ACTION_Tilt Left": "Olhe para a esquerda.",
  "LIVENESS_ACTION_Tilt Right": "Olhe para a direita.",
  "LIVENESS_ACTION_Tilt Up": "Olhar para cima",
  "LIVENESS_ACTION_Tilt Down": "Olhe para baixo.",
  "LIVENESS_ACTION_Look Straight": "Olhar em frente",
  "LIVENESS_ACTION_No Action": "Sem ação",
  "LIVENESS_ACTION_PROCESSING_LIVENESS": "Processamento da vivacidade",
  "LIVENESS_RESULT_Thank you!.Failed": "Falhou",
  "LIVENESS_RESULT_Thank you!.Passed": "Aprovado",
  "LIVENESS_RESULT_Thank you!.ActionTimedOut": "Ação expirada.",
  "LIVENESS_RESULT_Thank you!.Interrupted": "Interrompido",
  "LIVENESS_RESULT_Thank you!.Undefined": "Indefinido",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TITLE": "Olhar em frente",
  "LIVENESS_ACTION_LOOK_STRAIGHT_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_LOOK_LEFT_TITLE": "Rodar a cabeça ligeiramente para a esquerda",
  "LIVENESS_ACTION_LOOK_LEFT_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_LOOK_RIGHT_TITLE": "Rodar a cabeça ligeiramente para a direita",
  "LIVENESS_ACTION_LOOK_RIGHT_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_LOOK_UP_TITLE": "Rodar a cabeça ligeiramente para cima",
  "LIVENESS_ACTION_LOOK_UP_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_LOOK_DOWN_TITLE": "Rodar a cabeça ligeiramente para baixo",
  "LIVENESS_ACTION_LOOK_DOWN_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_SMILE_TITLE": "Sorrir",
  "LIVENESS_ACTION_SMILE_TEXT": "Manter sempre os olhos no ecrã",
  "LIVENESS_ACTION_FROWN_TITLE": "Franzir a testa",
  "LIVENESS_ACTION_FROWN_TEXT": "Mantenha os olhos no ecrã o tempo todo",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE": "Uh Oh...Estás muito perto.",
  "PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE": "Uh Oh...Estás muito perto.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FACE_CROPPED": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE": "Não conseguimos detetar um rosto na imagem. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE": "Uh Oh...Estás muito longe.",
  "PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE": "Uh Oh... Algo correu mal.",
  "ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES": "Não conseguimos detetar um rosto na imagem. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE": "Uh Oh...Não conseguimos detetar um rosto.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_UNKNOWN": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_None_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_None": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FailedExpressions": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_IMAGE_ERROR": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_INVALID_CONFIG": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_NULLPTR": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_LICENSE_ERROR": "Algo correu mal. Por favor, tente novamente.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE": "Uh Oh... Algo correu mal.",
  "PASSIVE_LIVENESS_ERROR_INVALID_META": "Algo correu mal. Por favor, tente novamente.",
  "INITIALIZING_TITLE": "Inicializando",
  "INITIALIZING_DESCRIPTION": "Verificando as capacidades de hardware, por favor aguarde...",
  "JOURNEY_STATE_STARTED": "Começou.",
  "JOURNEY_STATE_INPROGRESS": "Em progresso.",
  "JOURNEY_STATE_ENDED": "Terminado",
  "INFO_JOURNEY_STATE": "Estado",
  "INFO_JOURNEY_ACTION": "Ação",
  "INFO_JOURNEY_ACTION_ATTEMPT": "Tentativa de Ação",
  "INFO_JOURNEY_ID": "ID da jornada",
  "INFO_JOURNEY_RESULT": "Resultado",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE": "Mensagem de resultado",
  "RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE": "Esse ID que nos deu estava desatualizado – tente outra coisa",
  "INFO_JOURNEY_REFERENCE": "Referência",
  "FLOW_STATE_NONE": "Nenhum.",
  "FLOW_STATE_IDENTITY:FRONT": "Lado da Frente",
  "FLOW_STATE_IDENTITY:BACK": "Verso",
  "FLOW_STATE_ADDRESS": "Endereço",
  "FLOW_STATE_SELFIE": "Selfie",
  "FLOW_STATE_LIVENESS": "Vivacidade",
  "FLOW_STATE_COVID": "Covid",
  "PROVIDER_TITLE_CAMERA": "Câmera",
  "PROVIDER_TITLE_CROPPER": "Cropper",
  "PROVIDER_TITLE_FILESYSTEM_ID": "Carregue uma fotografia do seu documento de identidade",
  "PROVIDER_TITLE_FILESYSTEM_FACEMATCH": "Carregue uma fotografia sua",
  "PROVIDER_TITLE_FILESYSTEM_ADDRESS": "Envie uma foto do seu comprovativo de morada",
  "PROVIDER_TITLE_FILESYSTEM_COVID": "Carregue uma fotografia do seu documento Covid",
  "PROVIDER_TITLE_GATEWAY": "Portão",
  "PROVIDER_TITLE_LIVENESS": "Vivacidade",
  "PROVIDER_TITLE_LOGIN": "Entrar",
  "PROVIDER_TITLE_RESULTS": "Resultados",
  "PROVIDER_TITLE_SCANNER": "Digitalize o seu documento de identidade",
  "PROVIDER_TITLE_VIEW_ID": "Verifique a pré-visualização do seu Documento de Identidade",
  "PROVIDER_TITLE_VIEW_FACEMATCH": "Verifique a pré-visualização da sua selfie",
  "PROVIDER_TITLE_VIEW_ADDRESS": "Verifique a visualização do seu comprovativo de morada",
  "ROVIDER_TITLE_VIEW_COVID": "Confira a antevisão do seu Covid",
  "PROVIDER_SUBTITLE_FILESYSTEM_ID": "Por favor, carregue uma fotografia do seu documento de identidade que esteja nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH": "Por favor, carregue uma fotografia sua que esteja nítida, focada, não coberta e diretamente virada para",
  "PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS": "Faça o upload de uma fotografia do seu documento que esteja nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_FILESYSTEM_COVID": "Faça o upload de uma fotografia do seu documento que esteja nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_SCANNER_ID": "Coloque a página da fotografia do seu documento de identidade virada para baixo no scanner.",
  "PROVIDER_SUBTITLE_VIEW_ID": "Verifique se a visualização do seu documento está nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_VIEW_FACEMATCH": "Verifique se a visualização da sua selfie está nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_VIEW_ADDRESS": "Verifique se a visualização do seu documento está nítida, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_SUBTITLE_VIEW_COVID": "Verifique se a visualização do seu documento está clara, focada, não coberta e diretamente virada para a frente.",
  "PROVIDER_TITLE_SMART_CAPTURE": "Captura inteligente",
  "PROVIDER_TITLE_JOURNEY_SELECT": "Selecionar viagem",
  "PROVIDER_TITLE_TERMS_AND_CONDITIONS": "Termos e Condições",
  "PROVIDER_TITLE_USER_INPUT": "Por favor preencha o seguinte formulário",
  "FILESYSTEM_SUPPORTED_TYPES_FIRST": "Formatos aceitos:",
  "FILESYSTEM_SUPPORTED_TYPES_LIST": "JPG, PNG, PDF",
  "FILESYSTEM_SUPPORTED_TYPES_PDF": "PDF",
  "FILESYSTEM_SUPPORTED_TYPES_SECOND": "(no caso de",
  "FILESYSTEM_SUPPORTED_TYPES_THIRD": "apenas a primeira página será processada)",
  "FILESYSTEM_SUPPORTED_TYPES_START_SELFIE": "Formatos aceites: JPG, PNG",
  "FILESYSTEM_MAX_FILE_SIZE": "Tamanho de ficheiro: aceitamos qualquer tamanho de ficheiro inferior a",
  "FILESYSTEM_MAX_FILE_SIZE_NUMBER": "7,5 MB",
  "FILESYSTEM_CHECK_FILE_TOO_BIG": "O seu arquivo é muito grande. Faça o upload de um ficheiro inferior a 7,5 MB.",
  "FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT": "O seu ficheiro está no formato incorreto. Faça o upload de um dos formatos aceites.",
  "FILESYSTEM_IDENTITY_DOCUMENT": "Documento de Identidade",
  "FILESYSTEM_FACEMATCH": "Face Match",
  "FILESYSTEM_ADDRESS": "Comprovativo de endereço",
  "FILESYSTEM_COVID": "Covid",
  "FILESYSTEM_DRAG_DROP": "Arrastar e largar",
  "FILESYSTEM_OR": "ou",
  "FILESYSTEM_CHOOSE": "Escolha um ficheiro",
  "FILESYSTEM_UPLOADING": "Fazendo upload...",
  "TRIPLESCAN_GUIDANCE_TRYAGAIN": "Tente novamente",
  "FAILURE_REASON_REFER": "O seu documento de identidade falhou a validação.",
  "FAILURE_REASON_EXPIRED": "O seu documento de identidade expirou.",
  "FAILURE_REASON_NOT_ACCEPTED": "O seu documento de identidade não é um tipo de documento aceite.",
  "FAILURE_REASON_NOT_SUPPORTED": "O seu documento de identidade não pôde ser classificado ou não é suportado.",
  "PLEASE_TRY_AGAIN_REFER": "Por favor, tente novamente.",
  "PLEASE_TRY_AGAIN_EXPIRED": "Tente novamente com um documento válido.",
  "PLEASE_TRY_AGAIN_NOT_ACCEPTED": "Tente novamente com um documento diferente.",
  "PLEASE_TRY_AGAIN_NOT_SUPPORTED": "Por favor, tente novamente.",
  "BLUR_CHECK_REASON": "Desfoque - o documento não é claro;",
  "GLARE_CHECK_REASON": "Brilho - o documento fica ilegível devido a uma fonte de luz forte;",
  "RESOLUTION_CHECK_REASON": "Baixa Resolução – o documento não preenche o quadro corretamente;",
  "EDGES_CHECK_REASON": "Bordas em falta – o documento não está corretamente posicionado na moldura;",
  "VALIDATION_FAILED": "Falha na validação",
  "VALIDATION_FAILED_REASON_DOC_UNKNOWN": "- documento desconhecido.",
  "VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED": "- documento não aceite.",
  "VALIDATION_FAILED_REASON_DOC_EXPIRED": "- documento expirou.",
  "PREVIEW_INFO_TITLE_ID": "Exemplos de fotos boas e más",
  "PREVIEW_INFO_GOOD": "Bom",
  "PREVIEW_INFO_BAD": "Mau",
  "PREVIEW_INFO_GOOD_EXAMPLE_ID": "A foto é nítida, focada e diretamente virada para a frente.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID": "A foto deve mostrar todos os quatro cantos.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ID": "O documento não deve ser coberto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID": "A foto não deve estar desfocada.",
  "PREVIEW_INFO_TITLE_FACEMATCH": "Dicas para uma selfie de boa qualidade",
  "PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH": "A selfie é nítida, focada e diretamente virada para a frente.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH": "A selfie deve mostrar o rosto todo.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH": "O rosto não deve estar coberto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH": "A selfie não deve ficar desfocada.",
  "PREVIEW_INFO_TITLE_ADDRESS": "Dicas para uma foto de boa qualidade",
  "PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS": "A foto é nítida, focada e diretamente virada para a frente.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS": "A foto deve mostrar todos os quatro cantos.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS": "O documento não deve ser coberto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS": "A foto não deve estar desfocada.",
  "PREVIEW_INFO_TITLE_COVID": "Dicas para uma foto de boa qualidade",
  "PREVIEW_INFO_GOOD_EXAMPLE_COVID": "A foto é nítida, focada e diretamente virada para a frente.",
  "PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID": "A foto deve mostrar todos os quatro cantos.",
  "PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID": "O documento não deve ser coberto.",
  "PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID": "A foto não deve estar desfocada.",
  "ATTEMPTS_REMAINING": "Número de tentativas restantes:",
  "CAMERA_CAPTURE": "Ligue a câmara",
  "CAMERA_CAPTURE_START_BUTTON": "Iniciar captura automática",
  "CAMERA_CAPTURE_CAPTION": "Clique em Iniciar captura automática para começar",
  "CAMERA_PREVIEW_START": "Ligue a sua câmara para iniciar a captura automática",
  "CAMERA_CONDITION_BLUR": "Desfoque detetado",
  "CAMERA_CONDITION_CAPTURING": "Capturando",
  "CAMERA_CONDITION_UPLOADING": "A fazer upload... Aguarde",
  "CAMERA_CONDITION_ALIGNMENT": "Documento fora do quadro",
  "CAMERA_CONDITION_GLARE": "Brilho detectado",
  "VERIFYING_TITLE": "Verificando...",
  "PREPARING_PREVIEW_TITLE": "A preparar visualização...",
  "CAMERA_CONDITION_LOW_RESOLUTION": "Documento muito longe",
  "CAMERA_LOADING": "Abrindo a câmara...",
  "CAMERA_SMARTCAPTURE_ON": "CAPTURA AUTOMÁTICA - LIGADA",
  "CAMERA_SMARTCAPTURE_OFF": "CAPTURA AUTOMÁTICA - DESLIGADA",
  "CAMERA_CAPTURE_FRONT": "Posicione o lado com a foto do seu documento de identidade no quadro abaixo.",
  "CAMERA_MANUAL_CAPTURE_FRONT": "Posicione o seu Documento de Identidade dentro da moldura e clique no botão abaixo",
  "CAMERA_CAPTURE_BACK": "Coloque a PARTE TRASEIRA do seu documento de identidade dentro da moldura",
  "CAMERA_CAPTURE_SELFIE_CAPTION": "Posicione o rosto dentro da oval, olhe diretamente para a câmara e clique no botão abaixo para tirar uma selfie.",
  "AMERA_CAPTURE_ADDRESS_CAPTION": "Posicione o seu Comprovativo de Morada dentro da moldura e clique no botão abaixo para tirar uma fotografia.",
  "CAMERA_CAPTURE_COVID_CAPTION": "Posicione o seu documento Covid dentro da moldura e clique no botão abaixo para tirar uma fotografia.",
  "CAMERA_PREVENT_GLARE_HINT": "Afaste o documento das fontes de luz direta.",
  "CAMERA_PREVENT_BLUR_HINT": "Segure o documento ou dispositivo com firmeza.",
  "CAMERA_PREVENT_LOW_RES_HINT": "Coloque o documento totalmente dentro da moldura.",
  "CROPPER_RETRY": "Tentar novamente",
  "CROPPER_UPLOAD": "Carregar",
  "CROPPER_UPLOADING": "Fazendo upload...",
  "FILESYSTEM_SELECT": "Selecionar",
  "FILESYSTEM_DROP_IMAGE": "ou soltar imagem",
  "GATEWAY_CAMERA": "Câmara ativada",
  "GATEWAY_CANCEL": "Cancelar viagem",
  "LIVENESS_START": "Iniciar atividade",
  "PASSIVE_LIVENESS_START": "Tirar foto",
  "LOGIN_USERNAME": "Nome de usuário",
  "LOGIN_PASSWORD": "Senha",
  "LOGIN_SUBMIT": "Submeter",
  "RESULTS_DOCUMENTS": "Documentos",
  "RESULTS_DOCUMENTS_NONE": "Nenhum encontrado",
  "RESULTS_DOCUMENT_TYPE": "Tipo de documento",
  "RESULTS_DOCUMENT_RESULT": "Resultado do Documento",
  "RESULTS_EXTRACTED_FIELDS_NONE": "Detalhes do resultado",
  "RESULTS_DETAILS_NONE": "Nenhum encontrado",
  "RESULTS_NEW_JOURNEY": "Iniciar Nova Jornada",
  "RESULTS_NO_INFORMATION": "Não há informação para esta jornada",
  "RESULTS_LOGOUT": "Terminar sessão",
  "RESULTS_HIGH_LEVEL_Aborted": "Abortado",
  "RESULTS_HIGH_LEVEL_TCCDISAGREE": "T&C abortados",
  "RESULTS_HIGH_LEVEL_Expired": "Expirado",
  "RESULTS_HIGH_LEVEL_NotAccepted": "Não aceite",
  "RESULTS_HIGH_LEVEL_NotSupported": "Não suportado.",
  "RESULTS_HIGH_LEVEL_Notsupported": "Não suportado.",
  "RESULTS_HIGH_LEVEL_Passed": "Aprovado",
  "RESULTS_HIGH_LEVEL_Refer": "Referir",
  "RESULTS_HIGH_LEVEL_Undefined": "Indefinido",
  "RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT": "Resultado de Vida Acumulativa",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK": "Verificação do tipo de frente do documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK": "Documento Verso Verificação",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY": "Política de Bloqueio de Documentos",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY": "Data de Validade do Documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT": "Suporte de Documento",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION": "Validação de documentos",
  "RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY": "Política de Prova de Documentos",
  "RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION": "Validação do Facematch",
  "RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE": "Regra de Menores",
  "ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED": "Necessidade de sucesso",
  "RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK": "Verificar a compatibilidade do passaporte Covid",
  "RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK": "Verificações de dados",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED": "Falhou",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED": "Não necessário.",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED": "Aprovado",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED": "Ignorado",
  "RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED": "Indeterminado",
  "ADDITIONAL_CHECKS_DETAILS": "Verificações adicionais",
  "ADDITIONAL_CHECKS_DETAILS_NONE": "Nenhum encontrado",
  "ADDITIONAL_CHECKS_DETAIL_DATACHECKS": "Verificações de dados",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK": "Controlos de retrospetiva",
  "ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA": "N/A",
  "GBG_SCORES": "Pontuações GBG",
  "GBG_TRUST_SCORE": "Pontuação de confiança GBG",
  "GBG_SCORE": "Pontuação GBG",
  "VIEW_RETRY": "Mudar foto",
  "VIEW_CROP": "Colheita",
  "VIEW_CROPPING": "Recorte...",
  "VIEW_UPLOAD": "Carregar",
  "VIEW_UPLOADING": "Carregando...",
  "SMART_CAPTURE_INITIALIZING": "Começar",
  "SMART_CAPTURE_START": "Inicializando Smart Capture, Por Favor Aguarde...",
  "SCANNER_DESC_AVAILABLE": "O scanner está disponível. Coloque seu documento no scanner.",
  "SCANNER_DESC_PROCESSING": "A imagem está sendo processada pelo servidor.",
  "SCANNER_DESC_SCANNING": "A imagem está sendo escaneada pelo dispositivo.",
  "SCANNER_DESC_DISCONNECTED": "O scanner está desconectado da rede.",
  "SCANNER_DESC_NOT_CONNECTED": "O scanner não está conectado.",
  "SCANNER_DESC_OFFLINE": "O scanner está offline.",
  "SCANNER_DESC_BUSY": "O scanner está sendo usado por outro usuário na sua rede local.",
  "SCANNER_DESC_WAITING": "Aguardando a conexão ser estabelecida.",
  "SCANNER_DESC_LOADING": "Por favor, aguarde...",
  "SCANNER_TITLE_SCANNING": "Verificando...",
  "SCANNER_TITLE_DISCONNECTED": "DESCONECTADO",
  "SCANNER_TITLE_NOT_CONNECTED": "NÃO CONECTADO",
  "SCANNER_TITLE_OFFLINE": "Scanner offline",
  "SCANNER_TITLE_BUSY": "Scanner ocupado",
  "SCANNER_TITLE_WAITING": "ESPERANDO",
  "SCANNER_ACTION_REGISTER": "Registrar",
  "SCANNER_ACTION_RELEASE": "Libertação",
  "CANCEL_JOURNEY": "Cancelar",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE": "Carregar uma fotografia em vez disso",
  "MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE": "Tirar uma fotografia em vez disso",
  "JOURNEY_SELECT_CONTINUE": "Continuar",
  "HELP_MODAL_AUTOCAPTURE_TITLE": "Como tirar uma fotografia do seu documento de identificação",
  "HELP_MODAL_AUTOCAPTURE_SUBTITLE": "Quando a Captura automática está activada, o ecrã de captura tira automaticamente uma fotografia do seu documento quando reconhece que este tem qualidade suficiente.",
  "HELP_MODAL_AUTOCAPTURE_TIPS": "Sugestões para tirar uma fotografia de boa qualidade",
  "HELP_MODAL_AUTOCAPTURE_GLARE_TITLE": "Evitar o encandeamento",
  "HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE": "Afaste o documento de fontes de luz diretas.",
  "HELP_MODAL_AUTOCAPTURE_FAR_TITLE": "Documento demasiado longe",
  "AUTOCAPTURE_FAR_SUBTITLE": "Coloque o documento totalmente dentro da moldura.",
  "AUTOCAPTURE_BLUR_TITLE": "Evitar a desfocagem",
  "HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE": "Segure o documento ou o dispositivo com firmeza.",
  "HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE": "Ainda com dificuldades? Tire uma fotografia com a Captura manual",
  "HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE": "Captura manual",
  "HELP_MODAL_SELFIE_TITLE": "Como tirar uma selfie",
  "HELP_MODAL_SELFIE_SUBTITLE": "Olhe diretamente para a câmara e clique no botão de captura manual.",
  "HELP_MODAL_POA_TITLE": "Como tirar uma fotografia do seu comprovativo de morada",
  "HELP_MODAL_POA_SUBTITLE": "Posicione o seu documento dentro da moldura e clique no botão de captura para tirar uma fotografia do seu documento.",
  "HELP_MODAL_POA_TIPS": "Sugestões para tirar uma fotografia de boa qualidade",
  "HELP_MODAL_POA_GLARE_TITLE": "Evitar o encandeamento",
  "HELP_MODAL_POA_GLARE_SUBTITLE": "Afaste o documento de fontes de luz diretas.",
  "HELP_MODAL_POA_FAR_TITLE": "Documento demasiado longe",
  "HELP_MODAL_POA_FAR_SUBTITLE": "Coloque o documento totalmente dentro da moldura.",
  "HELP_MODAL_POA_BLUR_TITLE": "Evitar a desfocagem",
  "HELP_MODAL_POA_BLUR_SUBTITLE": "Segure o documento ou o dispositivo com firmeza.",
  "HELP_MODAL_POA_MANUAL_CAPTURE": "Ainda com dificuldades? Ativar a Captura manual",
  "HELP_MODAL_POA_TURN_MANUAL_CAPTURE": "Captura manual",
  "HELP_MODAL_COVID_TITLE": "Como tirar uma fotografia do seu documento Covid",
  "HELP_MODAL_COVID_SUBTITLE": "Posicione o seu documento dentro da moldura e clique no botão de captura para tirar uma fotografia do seu documento.",
  "HELP_MODAL_COVID_TIPS": "Sugestões para tirar uma fotografia de boa qualidade",
  "HELP_MODAL_COVID_GLARE_TITLE": "Evitar o encandeamento",
  "HELP_MODAL_COVID_GLARE_SUBTITLE": "Afaste o documento de fontes de luz diretas.",
  "HELP_MODAL_COVID_FAR_TITLE": "Documento demasiado longe",
  "HELP_MODAL_COVID_FAR_SUBTITLE": "Coloque o documento totalmente dentro da moldura.",
  "HELP_MODAL_COVID_BLUR_TITLE": "Evitar a desfocagem",
  "HELP_MODAL_COVID_BLUR_SUBTITLE": "Segure o documento ou o dispositivo com firmeza.",
  "HELP_MODAL_COVID_MANUAL_CAPTURE": "Ainda com dificuldades? Ativar a Captura manual",
  "HELP_MODAL_COVID_TURN_MANUAL_CAPTURE": "Captura manual",
  "HELP_MODAL_NEED_HELP": "Precisa de ajuda?",
  "EXCEPTION": "Ocorreu uma exceção inesperada",
  "EXCEPTION_AUTHORIZATION": "Não autorizado",
  "EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED": "A sua conta não está autorizada a aceder a este recurso",
  "EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID": "A combinação de nome de utilizador e palavra-passe não é válida",
  "EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED": "Tem de ativar a autenticação para utilizar esta funcionalidade",
  "EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED": "Não está autorizado para este processo",
  "EXCEPTION_BAD_REQUEST": "Pedido incorreto com o código de estado 400",
  "EXCEPTION_BAD_REQUEST_INVALID_IMAGE": "Não é uma imagem válida",
  "EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE": "A viagem está à espera de uma resposta",
  "EXCEPTION_FLOW_STATE_JOURNEY_ENDED": "Não é possível enviar pedidos. A viagem terminou",
  "EXCEPTION_FLOW_STATE_MISSING": "Estado do fluxo não encontrado",
  "EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION": "Callback deve ser uma função válida.",
  "EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING": "O nome do evento deve ser um valor de string.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER": "Prioridade deve ser um número.",
  "EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER": "Prioridade deve ser um número positivo.",
  "EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR": "O contêiner deve ser um elemento ou seletor.",
  "EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID": "Valor não é válido",
  "EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED": "O valor foi danificado",
  "EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING": "A configuração deve incluir um parâmetro backendUrl.",
  "EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING": "Os parâmetros fornecidos devem conter coordenadas.",
  "EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING": "Os parâmetros fornecidos devem conter imagens.",
  "EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING": "Os parâmetros fornecidos devem conter a palavra-passe",
  "EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING": "Os parâmetros fornecidos devem conter o nome de usuário.",
  "EXCEPTION_MISSING_REQUIRED_FIELD_MISSING": "Preencha todos os campos obrigatórios",
  "EXCEPTION_POSTCODE_FORMAT_ERROR": "O formato do código postal não é válido minLength:5 / maxLength:8",
  "EXCEPTION_HOUSENUMBER_FORMAT_ERROR": "O formato do nome/número da porta não é válido minLength:1 / maxLength:20",
  "EXCEPTION_STREETNAME_FORMAT_ERROR": "Nome da rua não é válido minLength:1 / maxLength:30",
  "EXCEPTION_TOWN_FORMAT_ERROR": "O formato da cidade não é válido minLength:1 / maxLength:20",
  "EXCEPTION_JOURNEY_DEFINITIONS_MISSING": "Não existem definições de percurso disponíveis para este canal",
  "EXCEPTION_NETWORK": "Ocorreu uma exceção de rede, verifique a sua ligação e tente novamente",
  "EXCEPTION_PLATFORM_BROWSER_ONLY": "Esta funcionalidade só pode ser utilizada no browser",
  "EXCEPTION_PLATFORM_UNSUPPORTED": "O seu ambiente não suporta esta funcionalidade",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED": "As permissões da câmara não foram concedidas, verifique as definições do seu browser",
  "EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE": "",
  "EXCEPTION_PLATFORM_CAMERA_NOT_READABLE": "Não foi possível aceder à câmara. Feche todas as outras aplicações e tente novamente",
  "EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE": "Não foram encontradas câmaras adequadas no seu dispositivo",
  "EXCEPTION_SERVER": "O pedido falhou com o código de estado 500",
  "EXCEPTION_SERVER_UNREACHABLE": "O pedido falhou, o servidor não pode ser acedido",
  "EXCEPTION_SERVER_DATA_NOT_PERSISTED": "Ocorreu um erro durante o processo. Os seus dados podem não ser mantidos",
  "EXCEPTION_SERVER_RESULT_NOT_PASSING": "O resultado atual não está a passar",
  "EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE": "O contexto do ecrã não está disponível",
  "EXCEPTION_TEMPLATE_CONTAINER_MISSING": "O contentor não está presente",
  "EXCEPTION_TEMPLATE_ELEMENTS_MISSING": "Elementos necessários em falta",
  "EXCEPTION_TEMPLATE_MISSING": "Modelo não encontrado",
  "EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING": "Não é possível encontrar o elemento de origem",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE": "Não é possível obter fornecedores de entrada",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED": "Não foram especificados fornecedores de entrada",
  "EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE": "O fornecedor de entradas não está disponível",
  "SUPPORTED_DOCUMENT_Account Statement": "Extrato da conta",
  "SUPPORTED_DOCUMENT_Agreement (Tenancy)": "Acordo (Arrendamento)",
  "SUPPORTED_DOCUMENT_Bank Document": "Documento Bancário",
  "SUPPORTED_DOCUMENT_Bank Letter": "Carta do Banco",
  "SUPPORTED_DOCUMENT_Bank Statement": "Extrato bancário",
  "SUPPORTED_DOCUMENT_Benefit Letter": "Carta de benefícios",
  "SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)": "Certidão (de nascimento, de casamento, de união de facto)",
  "SUPPORTED_DOCUMENT_Council Document": "Documento do Conselho",
  "SUPPORTED_DOCUMENT_Council Letter": "Carta do Conselho",
  "SUPPORTED_DOCUMENT_Council Tax": "Imposto municipal",
  "SUPPORTED_DOCUMENT_Driving License": "Carteira de Motorista",
  "SUPPORTED_DOCUMENT_Driving Licence": "Carta de Condução",
  "SUPPORTED_DOCUMENT_DWP Document": "Documento DWP",
  "SUPPORTED_DOCUMENT_HMRC Document": "Documento do HMRC",
  "SUPPORTED_DOCUMENT_Information Sheet": "Ficha de Informação",
  "SUPPORTED_DOCUMENT_Insurance Document": "Documento de Seguro",
  "SUPPORTED_DOCUMENT_Insurance Letter": "Carta de Seguro",
  "SUPPORTED_DOCUMENT_Invoice": "Fatura",
  "SUPPORTED_DOCUMENT_NIC Letter": "Carta do NIC",
  "SUPPORTED_DOCUMENT_NINO Letter": "Carta NINO",
  "SUPPORTED_DOCUMENT_Official Document": "Documento Oficial",
  "SUPPORTED_DOCUMENT_Official Letter": "Carta Oficial",
  "SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)": "Carta de reembolso (relacionada a impostos ou apoio social)",
  "SUPPORTED_DOCUMENT_Tax Letter": "Carta de Imposto",
  "SUPPORTED_DOCUMENT_Tax Statement": "Declaração de imposto",
  "SUPPORTED_DOCUMENT_Tel Bill": "Conta de telefone",
  "SUPPORTED_DOCUMENT_Tel Letter": "Carta de Tel",
  "SUPPORTED_DOCUMENT_Telecommunication Document": "Documento de Telecomunicações",
  "SUPPORTED_DOCUMENT_TV Licence": "Licença de TV",
  "SUPPORTED_DOCUMENT_University Letter": "Carta da Universidade",
  "SUPPORTED_DOCUMENT_Utility Bill": "Fatura de Serviços",
  "SUPPORTED_DOCUMENT_Utility Document": "Documento de Utilidade",
  "SUPPORTED_DOCUMENT_Utility Letter": "Carta de Utilidade",
  "SUPPORTED_DOCUMENT_Water Bil": "Bilhete de água",
  "SUPPORTED_DOCUMENT_Water Document": "Documento de Água",
  "SUPPORTED_DOCUMENT_Agents License": "Licença de Agente",
  "SUPPORTED_DOCUMENT_Electoral Card": "Cartão eleitoral",
  "SUPPORTED_DOCUMENT_Foreigner Identification Card": "Cartão de Identificação de Estrangeiro",
  "SUPPORTED_DOCUMENT_Health Card": "Cartão de Saúde",
  "SUPPORTED_DOCUMENT_Job License": "Licença de trabalho",
  "SUPPORTED_DOCUMENT_Membership Identification Card": "Cartão de identificação de sócio",
  "SUPPORTED_DOCUMENT_Military Identification Card": "Cartão de Identificação Militar",
  "SUPPORTED_DOCUMENT_National Identification Card": "Cartão de identificação nacional",
  "SUPPORTED_DOCUMENT_Passport": "Passaporte",
  "SUPPORTED_DOCUMENT_Travel Permit": "Permissão de Viagem",
  "SUPPORTED_DOCUMENT_Visa": "Visto",
  "SUPPORTED_DOCUMENT_Weapons Licence": "Licença de porte de arma",
  "SUPPORTED_DOCUMENT_Selfie Photo": "Fotografia selfie",
  "SUPPORTED_DOCUMENT_Unknown": "Desconhecido",
  "SUPPORTED_DOCUMENT_COVIDPAS": "Passe Covid",
  "EXTRACTED_FIELDS_AddressFull": "Endereço Completo",
  "EXTRACTED_FIELDS_AddressCity": "Endereço Cidade",
  "EXTRACTED_FIELDS_AddressPostCode": "Código Postal do Endereço",
  "EXTRACTED_FIELDS_LastNameFirstPart": "Apelido Primeira Parte",
  "EXTRACTED_FIELDS_Sex": "Género",
  "EXTRACTED_FIELDS_BirthPlace": "Local de nascimento",
  "EXTRACTED_FIELDS_IssueNumber": "Número da edição",
  "EXTRACTED_FIELDS_DocumentNumberCheckDigit": "Dígito de Verificação do Número do Documento",
  "EXTRACTED_FIELDS_BirthDate": "Data de nascimento",
  "EXTRACTED_FIELDS_DocumentNumber": "Número do Documento",
  "EXTRACTED_FIELDS_FirstName": "Primeiro Nome",
  "EXTRACTED_FIELDS_ArbitraryDigit": "Dígito Arbitrário",
  "EXTRACTED_FIELDS_FirstNameInitial": "Inicial do Primeiro Nome",
  "EXTRACTED_FIELDS_ExpiryDate": "Data de validade",
  "EXTRACTED_FIELDS_IssueDate": "Data de emissão",
  "EXTRACTED_FIELDS_LastName": "Sobrenome",
  "EXTRACTED_FIELDS_LicenseCategory": "Categoria de Licença",
  "EXTRACTED_FIELDS_DocumentCategory": "Categoria de documento",
  "EXTRACTED_FIELDS_DocumentType": "Tipo de Documento",
  "EXTRACTED_FIELDS_NationalityCode": "Código de Nacionalidade",
  "EXTRACTED_FIELDS_MiddleName": "Nome do meio",
  "EXTRACTED_FIELDS_FirstIssuanceDate": "Data da Primeira Emissão",
  "EXTRACTED_FIELDS_SecondLastName": "Segundo Sobrenome",
  "EXTRACTED_FIELDS_FullName": "Nome Completo",
  "EXTRACTED_FIELDS_PersonalNumber": "Número Pessoal",
  "EXTRACTED_FIELDS_NationalityName": "Nacionalidade",
  "EXTRACTED_FIELDS_BarcodeItems": "Código de barras",
  "EXTRACTED_FIELDS_BirthPlaceCity": "Cidade de Nascimento",
  "EXTRACTED_FIELDS_BirthPlaceState": "Estado de Nascimento",
  "EXTRACTED_FIELDS_BirthPlaceCountry": "País de nascimento",
  "EXTRACTED_FIELDS_MRZFull": "MRZ completo",
  "EXTRACTED_FIELDS_MRZLine1": "Linha MRZ 1",
  "EXTRACTED_FIELDS_MRZLine2": "Linha MRZ 2",
  "EXTRACTED_FIELDS_MRZLine3": "Linha MRZ 3",
  "EXTRACTED_FIELDS_ObservationPage": "Página de Observação",
  "EXTRACTED_FIELDS_IssuingAuthority": "Autoridade Emissora",
  "EXTRACTED_FIELDS_IssuingLocation": "Local de Emissão",
  "EXTRACTED_FIELDS_MaritalStatus": "Estado Civil",
  "EXTRACTED_FIELDS_Occupation": "Ocupação",
  "EXTRACTED_FIELDS_AlienNumber": "Número Alienígena",
  "EXTRACTED_FIELDS_Employer": "Empregador",
  "EXTRACTED_FIELDS_AddressLine1": "Linha de Endereço 1",
  "EXTRACTED_FIELDS_AddressLine2": "Linha de Endereço 2",
  "EXTRACTED_FIELDS_AddressLine3": "Linha de Endereço 3",
  "EXTRACTED_FIELDS_AddressLine4": "Linha de Endereço 4",
  "EXTRACTED_FIELDS_AddressState": "Estado",
  "EXTRACTED_FIELDS_AddressDistrict": "Distrito",
  "EXTRACTED_FIELDS_AddressBuildingNumber": "Número do prédio",
  "EXTRACTED_FIELDS_AddressBuildingName": "Nome do Edifício",
  "EXTRACTED_FIELDS_AddressStreet": "Rua",
  "EXTRACTED_FIELDS_AddressCountry": "País",
  "EXTRACTED_FIELDS_RefAddressFull": "Endereço de referência",
  "EXTRACTED_FIELDS_RefAddressLine1": "Endereço de referência Linha 1",
  "EXTRACTED_FIELDS_RefAddressLine2": "Endereço de referência Linha 2",
  "EXTRACTED_FIELDS_RefAddressLine3": "Endereço de referência Linha 3",
  "EXTRACTED_FIELDS_RefAddressLine4": "Endereço de referência Linha 4",
  "EXTRACTED_FIELDS_RefAddressCity": "Endereço de referência Cidade",
  "EXTRACTED_FIELDS_RefAddressState": "Endereço de Referência Estado",
  "EXTRACTED_FIELDS_RefAddressDistrict": "Referência Endereço Distrito",
  "EXTRACTED_FIELDS_RefAddressBuildingNumber": "Número do Edifício do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressBuildingName": "Endereço de Referência Nome do Edifício",
  "EXTRACTED_FIELDS_RefAddressSubBuildingName": "Nome do Edifício Sub Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressStreet": "Rua de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressCountry": "Endereço de referência País",
  "EXTRACTED_FIELDS_RefAddressPostCode": "Endereço de Referência Código Postal",
  "EXTRACTED_FIELDS_HealthNumber": "Número de Saúde",
  "EXTRACTED_FIELDS_Endorsements": "Aprovações",
  "EXTRACTED_FIELDS_Constraints": "Restrições",
  "EXTRACTED_FIELDS_LicenseMarine": "Licença Marítima",
  "EXTRACTED_FIELDS_Height": "Altura",
  "EXTRACTED_FIELDS_Weight": "Peso",
  "EXTRACTED_FIELDS_HairColor": "Cor do cabelo",
  "EXTRACTED_FIELDS_EyeColor": "Cor dos olhos",
  "EXTRACTED_FIELDS_LensData": "Visão",
  "EXTRACTED_FIELDS_SocialSecurityNumber": "Número de Seguro Social",
  "EXTRACTED_FIELDS_NationalInsuranceNumber": "Número de Seguro Nacional",
  "EXTRACTED_FIELDS_Race": "Corrida",
  "EXTRACTED_FIELDS_MotherName": "Nome da mãe",
  "EXTRACTED_FIELDS_FatherName": "Nome do pai",
  "EXTRACTED_FIELDS_Parents": "Pais",
  "EXTRACTED_FIELDS_Remarks": "Observações",
  "EXTRACTED_FIELDS_DistinguishingMarks": "Marcas Distintivas",
  "EXTRACTED_FIELDS_PeriodOfStay": "Período de permanência",
  "EXTRACTED_FIELDS_TaxNumber": "Número de Identificação Fiscal",
  "EXTRACTED_FIELDS_Donor": "Doador",
  "EXTRACTED_FIELDS_RFIDG1": "Grupo 1 de Dados Brutos RFID",
  "EXTRACTED_FIELDS_RFIDG2": "Grupo 2 de Dados Brutos RFID",
  "EXTRACTED_FIELDS_RFIDG3": "Grupo 3 de Dados Brutos RFID",
  "EXTRACTED_FIELDS_RFIDG15": "Grupo 4 de Dados Brutos RFID",
  "EXTRACTED_FIELDS_RFIDSOD": "Grupo de Dados Brutos RFID 5",
  "EXTRACTED_FIELDS_PortraitPhoto": "Foto de Retrato Extraída",
  "EXTRACTED_FIELDS_Title": "Título",
  "EXTRACTED_FIELDS_IssueDate2": "Data da segunda emissão",
  "EXTRACTED_FIELDS_ExpiryDate2": "Segunda Data de Validade",
  "EXTRACTED_FIELDS_LicenseCategory2": "Segunda Categoria de Licença",
  "EXTRACTED_FIELDS_IssueDate3": "Data da Terceira Emissão",
  "EXTRACTED_FIELDS_ExpiryDate3": "Terceira Data de Vencimento",
  "EXTRACTED_FIELDS_LicenseCategory3": "Terceira Categoria de Licença",
  "EXTRACTED_FIELDS_IssueDate4": "Quarta Data de Emissão",
  "EXTRACTED_FIELDS_ExpiryDate4": "Quarta Data de Validade",
  "EXTRACTED_FIELDS_LicenseCategory4": "Quarta Categoria de Licença",
  "EXTRACTED_FIELDS_MRZCode1": "Código MRZ 1",
  "EXTRACTED_FIELDS_MRZCode2": "Código MRZ 2",
  "EXTRACTED_FIELDS_MRZStandardType": "Tipo padrão MRZ",
  "EXTRACTED_FIELDS_AddressStreetSuffix": "Sufixo de rua",
  "EXTRACTED_FIELDS_AddressStreetType": "Tipo de rua",
  "EXTRACTED_FIELDS_AddressUnitNumber": "Endereço Número da unidade",
  "EXTRACTED_FIELDS_LicenseNumber": "Número de Licença",
  "EXTRACTED_FIELDS_AddressStateCode": "Código do Estado",
  "EXTRACTED_FIELDS_AddressStreetTypeAbbreviation": "Abreviatura da rua",
  "EXTRACTED_FIELDS_AddressUnitType": "Tipo de Unidade de Endereço",
  "EXTRACTED_FIELDS_AddressDeliveryPointIdentifier": "Identificador do ponto de entrega",
  "EXTRACTED_FIELDS_AgeCategory": "Categoria de Idade",
  "EXTRACTED_FIELDS_ChildernCount": "Número de crianças",
  "EXTRACTED_FIELDS_EntryMode": "Modo de entrada",
  "EXTRACTED_FIELDS_VAFNumber": "Número VAF",
  "EXTRACTED_FIELDS_AddressLine5": "Linha de Endereço 5",
  "EXTRACTED_FIELDS_RFIDPortraitPhoto": "Retrato de Foto RFID",
  "EXTRACTED_FIELDS_RefAddressLine5": "Linha de Endereço de Referência 5",
  "EXTRACTED_FIELDS_RefAddressStateCode": "Endereço de Referência Estado",
  "EXTRACTED_FIELDS_RefAddressStreetType": "Tipo de Rua do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation": "Abreviação do Tipo de Rua do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressStreetSuffix": "Endereço de referência Sufixo da rua",
  "EXTRACTED_FIELDS_RefAddressUnitNumber": "Número da Unidade de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressUnitType": "Tipo de Unidade de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressPostcodeType": "Referência Endereço Código postal Tipo",
  "EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier": "Identificador de Ponto de Entrega de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressPOBoxNumber": "Número da Caixa Postal do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressDependentLocality": "Localidade Dependente do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressDoubleDependentLocality": "Localidade Dependente Dupla de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressThoroughfare": "Endereço de Referência Via",
  "EXTRACTED_FIELDS_RefAddressThoroughfareDesc": "Descrição do Endereço de Referência da Via Pública",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfare": "Rua Dependente de Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc": "Descrição do Logradouro Dependente do Endereço de Referência",
  "EXTRACTED_FIELDS_RefAddressSubBuildingNumber": "Número do Edifício do Sub-Endereço de Referência",
  "EXTRACTED_FIELDS_AddressSubBuildingNumber": "Número do subedifício",
  "EXTRACTED_FIELDS_AddressSubBuildingName": "Nome do Edifício",
  "EXTRACTED_FIELDS_AddressPostCodeType": "Tipo de Código Postal",
  "EXTRACTED_FIELDS_IssuingAuthorityType": "Tipo de Autoridade Emissora",
  "EXTRACTED_FIELDS_Signature": "Assinatura",
  "EXTRACTED_FIELDS_Hologram": "Holograma",
  "EXTRACTED_FIELDS_CardNumber": "Número do cartão",
  "EXTRACTED_FIELDS_MiddleNameInitial": "Inicial do nome do meio",
  "EXTRACTED_FIELDS_PermitNumber": "Número de Permissão",
  "EXTRACTED_FIELDS_ReferenceNumber": "Número de referência",
  "EXTRACTED_FIELDS_CustomerNumber": "Número do Cliente",
  "EXTRACTED_FIELDS_BOSNumber": "Número BOS",
  "EXTRACTED_FIELDS_StudentID": "Student Identification Number",
  "EXTRACTED_FIELDS_MembershipNumber": "Número de associação",
  "EXTRACTED_FIELDS_LicenseType": "Tipo de Licença",
  "EXTRACTED_FIELDS_LicenseType2": "Tipo de Licença 2",
  "EXTRACTED_FIELDS_LicenseType3": "Tipo de Licença 3",
  "EXTRACTED_FIELDS_LicenseType4": "Tipo de Licença 4",
  "EXTRACTED_FIELDS_DocumentTypeCode": "Código do Tipo de Documento",
  "EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit": "MRZ Dígito de controlo",
  "EXTRACTED_FIELDS_MRZBirthDateCheckDigit": "Dígito de Verificação da Data de Nascimento MRZ",
  "EXTRACTED_FIELDS_MRZExpiryDateCheckDigit": "Dígito de controlo da data de expiração da MRZ",
  "EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit": "Dígito de Verificação do Número Pessoal MRZ",
  "EXTRACTED_FIELDS_MRZCompositeCheckDigit": "Dígito de controlo composto MRZ",
  "EXTRACTED_FIELDS_SecondaryPortraitPhoto": "Foto de Retrato Secundário",
  "EXTRACTED_FIELDS_Fingerprint": "Impressão digital",
  "EXTRACTED_FIELDS_VersionNumber": "Número da Versão",
  "EXTRACTED_FIELDS_Conditions": "Condições",
  "EXTRACTED_FIELDS_NickName": "Apelido",
  "EXTRACTED_FIELDS_AddressApartmentNumber": "Número do apartamento",
  "EXTRACTED_FIELDS_AddressFloorNumber": "Número do Andar",
  "EXTRACTED_FIELDS_FirstNameLocal": "Primeiro Nome Local",
  "EXTRACTED_FIELDS_LastNameLocal": "Sobrenome Local",
  "EXTRACTED_FIELDS_FullNameLocal": "Nome Completo Local",
  "EXTRACTED_FIELDS_BirthPlaceLocal": "Local de Nascimento",
  "EXTRACTED_FIELDS_IssuingAuthorityLocal": "Autoridade Emissora Local",
  "EXTRACTED_FIELDS_MotherNameLocal": "Nome da Mãe Local",
  "EXTRACTED_FIELDS_FatherNameLocal": "Nome do Pai Local",
  "EXTRACTED_FIELDS_AddressFullLocal": "Endereço completo Local",
  "EXTRACTED_FIELDS_MiddleNameLocal": "Nome do meio Local",
  "EXTRACTED_FIELDS_AddressLine1Local": "Endereço Linha1 Local",
  "EXTRACTED_FIELDS_AddressLine2Local": "Endereço Linha2 Local",
  "EXTRACTED_FIELDS_AddressLine3Local": "Endereço Linha3 Local",
  "EXTRACTED_FIELDS_IndRefNumber1": "Número de Referência Individual 1",
  "EXTRACTED_FIELDS_IndRefNumber2": "Número de Referência Individual 2",
  "EXTRACTED_FIELDS_IndRefNumber3": "Número de Referência Individual 3",
  "EXTRACTED_FIELDS_IndRefNumber4": "Número de Referência Individual 4",
  "EXTRACTED_FIELDS_IndRefNumber5": "Número de Referência Individual 5",
  "EXTRACTED_FIELDS_Name1": "Nome 1",
  "EXTRACTED_FIELDS_Name2": "Nome 2",
  "EXTRACTED_FIELDS_Name3": "Nome 3",
  "EXTRACTED_FIELDS_Name4": "Nome 4",
  "EXTRACTED_FIELDS_Name5": "Nome 5",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_1": "Nome do destinatário 1",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_2": "Nome do destinatário 2",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_3": "Nome do destinatário 3",
  "EXTRACTED_FIELDS_RECIPIENT_NAME_4": "Nome do destinatário 4",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL": "Endereço do destinatário Completo",
  "EXTRACTED_FIELDS_IBAN": "IBAN Número da conta",
  "EXTRACTED_FIELDS_ACCOUNT_NUM": "Número de conta",
  "EXTRACTED_FIELDS_ISSUER": "Emissor",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY": "Endereço do destinatário Cidade",
  "EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE": "Endereço do destinatário Código postal",
  "EXTRACTED_FIELDS_DAY": "Dia",
  "EXTRACTED_FIELDS_MONTH": "Mês",
  "EXTRACTED_FIELDS_YEAR": "Ano",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_1": "Valor facultativo 1",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_2": "Valor facultativo 2",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_3": "Valor facultativo 3",
  "EXTRACTED_FIELDS_OPTIONAL_VALUE_4": "Valor facultativo 4",
  "EXTRACTED_FIELDS_ISSUING_STATE_NAME": "Nome do Estado emissor",
  "EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID": "Id do tipo de documento da frente",
  "EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID": "Identificação do tipo de documento no verso",
  "HASNOCAMERA_TITLE": "Oops, não foi possível reconhecer uma câmara no seu dispositivo!",
  "HASNOCAMERA_DESCRIPTION": "Parece que o seu dispositivo não tem uma câmara. Tente novamente num dispositivo diferente que tenha uma câmara funcional para poder executar todos os passos necessários.",
  "EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT": "Tipo de Covid Id",
  "USER_INPUT_FIRST_NAME": "Nome próprio",
  "USER_INPUT_MIDDLE_NAME": "Nome do meio",
  "USER_INPUT_LAST_NAME": "Último nome",
  "USER_INPUT_DOB": "Data de nascimento",
  "USER_INPUT_HOUSE_NAME_NUMBER": "Nome/número da casa*",
  "USER_INPUT_STREET_NAME": "Nome da rua*",
  "USER_INPUT_TOWN": "Localidade*",
  "USER_INPUT_POSTAL_CODE": "Código postal*",
  "USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE": "por exemplo, Casa/35",
  "USER_INPUT_STREET_NAME_EXAMPLE": "ex. Rua Test",
  "USER_INPUT_TOWN_EXAMPLE": "por exemplo, Somewhere",
  "USER_INPUT_POSTAL_CODE_EXAMPLE": "p. ex. CH496 (sem espaços)",
  "SYSTEM_NOT_ABLE": "O sistema não conseguiu digitalizar o documento",
  "TRY_AGAIN": "Tente novamente",
  "HINTS_DISABLED_HEADER": "Dicas estão desativadas no modo manual",
  "HINTS_DISABLED_DESCRIPTION": "Se deseja ativar as dicas para tirar uma foto, mude para o modo CAPTURA AUTOMÁTICA",
  "YOU_HAVE": "Você tem",
  "PICTURE_VERIFYING": "Verificando...",
  "HOW_TO_TAKE_PHOTO_CORRECTLY": "Como tirar uma foto corretamente",
}